import type { IMapRequest } from "stores/map";

import { IUser } from "models/User";
import { EntityKind } from "models/entityKind";

import { generateFacilitiesRequest } from "./facilities";
import { generateWellsRequest } from "./wells";

export type MapRequestParams = Partial<IMapRequest & IUser>;

export const MAP_REQUEST_GENERATOR = {
  [EntityKind.Facility]: generateFacilitiesRequest,
  [EntityKind.Well]: generateWellsRequest
};

export function generateMapRequest({
  entityKind,
  states
}: {
  entityKind: EntityKind;
  states: MapRequestParams;
}): Maybe<IMapRequest> {
  const requestGenerator = MAP_REQUEST_GENERATOR[entityKind];
  if (!requestGenerator) {
    throw new Error(`Unknown entity kind: ${entityKind} to create map request`);
  }
  return requestGenerator(states);
}
